import React from 'react';
import {Icon} from 'semantic-ui-react';
import {FormattedMessage} from 'react-intl';

const FailureDisplay = props => (
  <span className='error-text-color'>
    <FormattedMessage id={props.labelKey} />
    &nbsp;
    <Icon name='remove circle' />
  </span>
);

export default FailureDisplay;



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/tabPanes/FailureDisplay.jsx